export default {
  HLConfigApi: {
    base: {
      serviceCodes: 'api/hlBaseConfig/serviceCodes',
      baseConfigOptions: 'api/hlBaseConfig/getBaseConfigOptions',
      configPageList: 'api/hlBaseConfig/configPageList',
      saveOrUpdateConfig: 'api/hlBaseConfig/saveOrUpdateConfig',
      delConfigs: 'api/hlBaseConfig/delConfigs',
      changeConfigStatus: 'api/hlBaseConfig/changeConfigStatus',
      getActiveConfig: 'api/hlBaseConfig/getActiveConfig'
    },
    callRecord: {
      callPageList: 'api/callRecordApi/callPageList',
      delCallRecords: 'api/callRecordApi/delCallRecords',
      exportCallPageList: 'api/callRecordApi/exportCallPageList',
      // 新建通话记录
      pushCallRecord: 'api/callRecordApi/pushCallRecord',
      // 更新通话记录
      updateCallRecord: 'api/callRecordApi/updateCallRecord',
      // 挂断电话
      hangUpRecord: 'api/callRecordApi/hangUpRecord',
      // 获取通话记录
      loadCallRecord: 'api/callRecordApi/loadCallRecord',
      // 获取通话文本记录
      callConversationInfo: 'api/callRecordApi/callConversationInfo',
      // 创建监听记录
      pushCallRecordMonitorLog: 'api/callRecordApi/pushCallRecordMonitorLog',
      // 获取已存通话文本记录
      callConInfo: 'api/callRecordApi/callConInfo',
      createLedger: 'api/callRecordApi/createLedger',
    },
    aliyunConfig: {
      callApi: '/api/aliyunApi/callApi',
      initData: 'api/aliyunApi/initData',

      createAccount: 'api/aliyunAccountApi/createAccount',
      updateAccount: 'api/aliyunAccountApi/updateAccount',
      delAccount: '/api/aliyunAccountApi/delAccount',
      systemAccountPageList: '/api/aliyunAccountApi/systemAccountPageList',
      delSystemAccountMapping: '/api/aliyunAccountApi/delSystemAccountMapping',
      systemAccounts: '/api/aliyunAccountApi/systemAccounts',
      addSystemAccountsToHLAccount: '/api/aliyunAccountApi/addSystemAccountsToHLAccount',

      // 云话务部分
      accountPageList: 'api/aliyunAccountApi/accountPageList',
      delAccounts: 'api/aliyunAccountApi/delAccounts',

      // 技能组部分
      creatGroup: 'api/aliyunAccountApi/creatGroup',
      updateGroup: 'api/aliyunAccountApi/updateGroup',
      delGroup: 'api/aliyunAccountApi/delGroup',
      //技能组话务
      groupAccountPageList: 'api/aliyunAccountApi/groupAccountPageList',
      delGroupAccountMapping: 'api/aliyunAccountApi/delGroupAccountMapping',
      changeLevel: 'api/aliyunAccountApi/changeLevel',
      // 当前实例的所有坐席
      allAccount: 'api/aliyunAccountApi/allAccount',
      addAccountToGroup: 'api/aliyunAccountApi/addAccountToGroup',
      // 呼出号码部分
      groupPhonePageList: 'api/aliyunAccountApi/groupPhonePageList',
      delGroupPhoneMapping: 'api/aliyunAccountApi/delGroupPhoneMapping',
      allPhoneNumbers: 'api/aliyunAccountApi/allPhoneNumbers',
      addPhoneToGroup: 'api/aliyunAccountApi/addPhoneToGroup',

      // RAM部分
      getRAMSecretKeyList: 'api/aliyunRAMApi/getRAMSecretKeyList',
      createRAMSecretKey: 'api/aliyunRAMApi/createRAMSecretKey',
      delRAMSecretKey: 'api/aliyunRAMApi/delRAMSecretKey',
      changeRAMSecretKeyStatus: 'api/aliyunRAMApi/changeRAMSecretKeyStatus',
      delRAMUser: 'api/aliyunRAMApi/delRAMUser',
      createRAMUser: 'api/aliyunRAMApi/createRAMUser',
      updateRAMUser: 'api/aliyunRAMApi/updateRAMUser',
      getDefaultDomain: 'api/aliyunRAMApi/getDefaultDomain'
    }
  }
}
